import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTop from './newsTop';
import FLive from './fLive';

class NewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { newsTopData, liveAd },
        } = this.props;

        return (
            <div className={styles.news_box}>
                <NewsTop content={newsTopData} />
                <FLive ad={liveAd} />
            </div>
        );
    }
}

export default errorBoundary(NewsBox);
